export default {
  low: {
    title:
      'Low Confidence Scores indicate that the Credit Insights are likely to be inaccurate. To avoid low Confidence Scores:',
    points: [
      'Upload true PDF document(s)',
      'Upload document(s) without missing pages',
      'Upload open banking data where possible',
      'Do not upload document(s) which have been stitched together (i.e. each document is a merged PDF of other PDFs and/or images)',
    ],
  },
  high: {
    title: 'High Confidence Scores indicate that Inscribe has:',
    points: [
      "Parsed out transactions from customer's bank statement correctly",
      "Accurately categorised the customer's transactions",
      'Provided highly accurate credit insights',
    ],
  },
};
